export default "__VITE_PUBLIC_ASSET__a028a836__"